export var FileExtension = /*#__PURE__*/ function(FileExtension) {
    FileExtension["MPD"] = "mpd";
    FileExtension["M3U8"] = "m3u8";
    return FileExtension;
}({});

//# sourceMappingURL=stream-proxy.enums.js.map